import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "../../components/Buttons";
import { useModal } from "../../contexts/ModalContext";
import { useDialog } from "../../contexts/DialogContext";
import { useSocket } from "../../contexts/SocketContext";
import { useSocketPending } from "../../contexts/SocketPendingContext";
import { requestAuth } from "../../components/services/RequestService";
import CallServiceTable from "../../components/Tables/CallServiceTable";
import ListDocument from "../../components/common/ListDocument";
import RenderLiquidaciónProforma from "../../containers/ManegeProcedure/RenderLiquidaciónProforma";
import GenerateFileDelivery from "../../containers/ManegeProcedure/GenerateFileDelivery";
import { H3, Anchor } from "../../components/Text";
import { NewProcedure, FillForm, SendProcedure } from "../../containers/steps";
import { DialogConfirmation } from "../../components/Modal";
import ListDocumentVerify from "../../components/common/ListDocumentVerify";
import TableLisDocument from "../../components/common/TableLisDocument";
import { useAuth } from "../../contexts/AuthContext";
import { validateArray } from "../../utils/validate";
import { addFiltersDefault, headerList, monthList } from "../../utils/constant";
import config from "../../config.json";
import { Tooltip } from "react-tippy";

const StepsTramites = () => {
  const { rolId, step, typeId } = useParams();
  const { connectionPending, setConnectionId } = useSocketPending();
  const { openModal, onClose } = useModal();
  const { openDialog, dialogClose } = useDialog();
  const { user, currentRow, setCurrentRow } = useAuth()

  const [reload, setReload] = useState(false);

  useEffect(() => {
    const connect = connectionPending.connect;
    if (connect) {
      connect.start().then(() => {
        connect.on("ListTypeProcedure", () => {
          // console.log("ListTypeProcedure table");
          setReload((a) => !a);
        });
        requestAuth(
          "post",
          `/auth/SocketConnection/${connect.connection.connectionId}`
        ).then(() => {
          setConnectionId(connect.connection.connectionId);
        });
      });
      // .catch((e) => console.log("Connection failed: ", e));
    }
  }, []);

  function handleAdd(reloadTable) {
    openModal(
      <NewProcedure
        reload={reloadTable}
        onClose={onClose}
        openModal={openModal}
      />
    );
  }

  function handleFillForm(procedure, reloadTable) {
    openModal(
      <FillForm
        procedure={procedure}
        reload={reloadTable}
        onClose={onClose}
        openModal={openModal}
        rolId={rolId}
        step={step}
        typeId={typeId}
        indexNumber='codigoDeInterno'
        handleSendProcedure={handleSendProcedure}
      />
    );
  }
  // function listDocumentPdf(procedure) {
  //   openDialog(<RenderPdf procedure={procedure} />)
  // }
  function generateFileDelivery(procedure) {
    openDialog(<GenerateFileDelivery procedure={procedure} />);
  }
  function handleSendProcedure(procedure, reloadTable) {
    openModal(
      <SendProcedure
        openModal={openModal}
        procedure={procedure}
        reload={reloadTable}
        onClose={onClose}
      />
    );
  }
  function generateSettlementProforma(procedure) {
    openModal(<RenderLiquidaciónProforma procedure={procedure} />);
  }
  function handleDocument(procedure) {
    openModal(<ListDocument procedure={procedure} />);
  }
  function handleDocumentVerify(procedure) {
    openModal(<ListDocumentVerify procedure={procedure} />);
  }
  function handleBreakdownDocument(procedure) {
    if (config.hostname === window.location.hostname) {
      console.log(
        user?.institutionParam?.find((i) => i.code === "mediaRequest")?.value
      );
    } else {
      console.log(
        user?.institutionParam?.find((i) => i.code === "mediaRequest2")?.value
      );
    }
    openDialog(
      <DialogConfirmation
        children={
          <H3>
            ¿Estas seguro que desea unir los documentos en un PDF?
            {/* <br />
            {
              config.hostname === window.location.hostname ?
              user?.institutionParam?.find(i => i.code === "mediaRequest")?.value
              :
              user?.institutionParam?.find(i => i.code === "mediaRequest2")?.value
            } */}
          </H3>
        }
        onClose={dialogClose}
        method="post"
        url={`/Utility/joinPdfs/${procedure.id}`}
        texBtn="Generar"
        handleSuccess={viewLinkDocument}
      />
    );
  }
  function viewLinkDocument(data) {
    openDialog(
      <div className="w-[300px]">
        <H3>Archivo generado</H3>
        <center>
          <Anchor
            className="text-[#264fbe] text-[1.4rem]"
            href={data.url}
            // href={`${validateUrlToOpen(data.url, user?.institutionParam)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar archivo
          </Anchor>
        </center>
        <br />
      </div>
    );
  }

  return (
    <>
      <CallServiceTable
        // urlApi={`/procedure/bystepbyproceduretypeid/${step}/proceduretypeid/${typeId}/rol/${rolId}`}
        urlApi={`/procedure/pag`}
        reloaders={[step]}
        aditionalParams={{
          Fieldnames: [
            "codigoDeInterno",
            "nroDeInterno",
            // "a1NúmeroDeDeclaración",
            "designacionDeLiquidador",
            "descripciónDeLaMercancía",
            "a4AduanaDeDespacho",
            "a1NúmeroDeDeclaración",
            "régimen/PatrónImportación",
            "javestCorrelativo"
          ],
          step: step,
          procedureTypeId: typeId,
          RolId: rolId
          // ...(status === "pending" ? { pending: true } : status === "complete" ? { pending: false } : {})
        }}
        downloadUrl={`/tradecruz/bystepbyproceduretypeid/${step}/proceduretypeid/${typeId}/rol/${rolId}`}
        download={true}
        addUrl={`userId=${localStorage.getItem("id")}`}
        reload={reload}
        component={({ reload }) => {
          return step === "1" ? (
            <Button onClick={() => handleAdd(reload)}>
              Agregar nuevo trámite
            </Button>
          ) : null;
        }}
        filters={[
          {
            name: "companyId",
            url: "/company/getallcompanies",
            label: "Todas las compañías",
            valueOption: "id",
            labelOption: "razonSocial",
          },
          // {
          //   name: "liquidator",
          //   url: "/Dropdown/rol_liquidator/options",
          //   label: "Todos los liquidadores",
          //   valueOption: "name",
          //   labelOption: "name",
          // },
          {
            name: "ConcatYears",
            default: "",
            label: "Gestión",
            type: "multiSelect",
            defaultValue: { value: '2026', label: '2026' },
            options: [
              {
                label: "2026",
                name: "2026",
                initial: true,
              },
              {
                label: "2025",
                name: "2025",
              },
              {
                label: "2024",
                name: "2024",
              },
              {
                label: "2023",
                name: "2023",
              },
              {
                label: "2022",
                name: "2022",
              },
              {
                label: "2021",
                name: "2021",
              },
              {
                label: "2020",
                name: "2020",
              },
              {
                label: "2019",
                name: "2019",
              },
            ],
          },
          // {
          //   name: "month",
          //   label: "Todos los meses",
          //   options: monthList,
          // },
          // {
          //   name: "gestor",
          //   url: "/Dropdown/rol_gestor/options",
          //   label: "Todos los gestores",
          //   valueOption: "name",
          //   labelOption: "name",
          // },
          // {
          //   name: "inCharges",
          //   url: "/Dropdown/rol_InCharge/options",
          //   label: "Todos los encargados",
          //   type: "multiSelect",
          //   valueOption: "id",
          //   labelOption: "name",
          // },
        ]}
        addFilters={addFiltersDefault}
        header={[
          ...headerList,
          {
            name: "Action",
            type: "custom",
            label: "Acciones",
            disabledOnClick: true,
            sticky: true,
            builder: (_, __, data, call, buttons) => {
              const listButton = buttons ? JSON.parse(buttons) : [];

              return (
                <div className="flex items-center justify-center gap-1 px-1">
                  <div
                    className={`text-red-500 text-lg w-8 flex justify-center items-center cursor-pointer border-2 rounded-lg border-[#1d4ed830] hover:border-[#1d4ed880]`}
                    onClick={() => { handleSendProcedure(data, call); setCurrentRow(data); }}
                  >
                    <Tooltip
                      title="Enviar"
                      position="right"
                      trigger="mouseenter"
                    >
                      <i className={"fas fa-share-square p-1"}></i>
                    </Tooltip>
                  </div>
                  {listButton && validateArray(listButton) ? (
                    <TableLisDocument
                      call={call}
                      listButton={listButton}
                      procedure={data}
                    />
                  ) : null}
                </div>
              );
            },
          },
        ]}
        onClick={handleFillForm}
      />
    </>
  );
};

export default StepsTramites;
